import { useEffect, useState } from "react";
import anketaService from "../../services/anketa.service";
import popunjeniOdgovorService from "../../services/popunjeniOdgovor.service";
import "./OdgovoriNaPitanjaChart.css";
import "./OdgovoriNaTekstualnaPitanja.css";
import { RightOutlined } from "@ant-design/icons";

const OdgovoriNaTekstualnaPitanja = ({ anketaId }) => {
  const [tekstualnaPitanja, setTekstualnaPitanja] = useState([]);
  const [odgovori, setOdgovori] = useState({});
  const [prikazaniOdgovori, setPrikazaniOdgovori] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pitanjaResponse = await anketaService.getPitanjaSaOdgovorima(
          anketaId
        );
        const pitanjaData = pitanjaResponse.data || [];

        const tekstualna = pitanjaData.filter((p) => p.tip === "TEKSTUALNO");
        setTekstualnaPitanja(tekstualna);

        const odgovoriResponses = await Promise.all(
          tekstualna.map(async (pitanje) => {
            try {
              const pitanjeId = pitanje.id_pitanje || pitanje.id;
              const odgovorData =
                await popunjeniOdgovorService.getAllByPitanjeId(pitanjeId);
              return { pitanjeId, odgovori: odgovorData.data };
            } catch (error) {
              return { pitanjeId: pitanje.id, odgovori: [] };
            }
          })
        );

        const sviOdgovori = odgovoriResponses.reduce(
          (acc, { pitanjeId, odgovori }) => {
            acc[pitanjeId] = odgovori;
            return acc;
          },
          {}
        );

        setOdgovori(sviOdgovori);
      } catch (error) {}
    };

    fetchData();
  }, [anketaId]);

  const toggleOdgovori = (pitanjeId) => {
    setPrikazaniOdgovori((prev) => ({
      ...prev,
      [pitanjeId]: !prev[pitanjeId],
    }));
  };

  return (
    <div className="anketa-statistika-div">
      {tekstualnaPitanja.length > 0 ? (
        tekstualnaPitanja
          .sort((a, b) => a.pozicija - b.pozicija)
          .map((pitanje) => {
            const pitanjeId = pitanje.id_pitanje || pitanje.id;
            const odgovoriNaPitanje = odgovori[pitanjeId] || [];

            return (
              <div key={pitanjeId} className="pitanje-container">
                <div
                  className="tekstualno-pitanje-tekst"
                  onClick={() => toggleOdgovori(pitanjeId)}
                >
                  <span className="tekstualno-ikonica-levo">
                    <RightOutlined
                      className={`ant-ikonica-toggle ${
                        prikazaniOdgovori[pitanjeId] ? "rotirana" : ""
                      }`}
                    />
                  </span>
                  <span className="tekstualno-tekst-centar">
                    {pitanje.pozicija}.{" "}
                    {pitanje.tekstPitanja || pitanje.tekst_pitanja}
                  </span>
                </div>

                {prikazaniOdgovori[pitanjeId] && (
                  <div className="tekstualni-odgovori-container">
                    <ul className="tekstualni-odgovori-lista">
                      {odgovoriNaPitanje.length > 0 ? (
                        odgovoriNaPitanje.map((odg, index) => (
                          <li key={index} className="tekstualni-odgovor-item">
                            {odg.odgovor_tekst || odg.odgovorTekst}
                          </li>
                        ))
                      ) : (
                        <li className="tekstualni-nema-odgovora">
                          Nema odgovora
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            );
          })
      ) : (
        <p className="loading-error-message">
          Nema tekstualnih pitanja za prikaz.
        </p>
      )}
    </div>
  );
};

export default OdgovoriNaTekstualnaPitanja;
